import React from 'react'
import { Modal } from 'reactstrap'
import { useTranslation } from 'react-i18next'

export interface PayoutAutopayOffModalProps {
  modal: boolean
  toggle: () => void
  handleConfirmPress: () => void
}

const PayoutAutopayOffModal: React.FC<PayoutAutopayOffModalProps> = ({
  modal,
  toggle,
  handleConfirmPress,
}) => {
  const { t } = useTranslation()

  return (
    <div>
      <Modal
        fade={false}
        className="modal-dialog--success modal-dialog--header"
        isOpen={modal}
        modalClassName="ltr-support"
        toggle={toggle}
        style={{ width: 377 }}
      >
        <div className="modal__header">
          <button
            className="lnr lnr-cross modal__close-btn"
            type="button"
            onClick={toggle}
          />
          <h4 className="text-modal  modal__title">
            {t('adminPage.autopayoutOffTitle')}
          </h4>
        </div>
        <div className="modal-info__inner-wrapper">
          <p className="modal-info__description">
            {t('adminPage.autopayoutOffText')}
          </p>
          <button
            className="btn btn-success modal-info__button"
            type="submit"
            onClick={handleConfirmPress}
          >
            {t('adminPage.confirmButton')}
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default PayoutAutopayOffModal
